import { ReactElement, useState } from 'react';
import { space } from '@op/opds.tokens';
import { Message } from '@messageformat/react';
import { Alert, Col, Row } from '@op/opds.opux';
import CourseTaskHeader from '../CourseTaskHeader';
import RadioQuestionTile from '../RadioQuestionTile';

const TaskOne = (): ReactElement => {
  const [selectedValue1, setSelectedValue1] = useState('');
  const [selectedValue2, setSelectedValue2] = useState('');
  const [selectedValue3, setSelectedValue3] = useState('');
  const [selectedValue4, setSelectedValue4] = useState('');
  const [selectedValue5, setSelectedValue5] = useState('');
  const [selectedValue6, setSelectedValue6] = useState('');
  return (
    <div style={{ marginBottom: space.default }}>
      <CourseTaskHeader questionNumber={1} totalQuestions={1} />
      <h3
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', marginTop: space.xxl }}
      >
        <Message id="course2.task1.title" />
      </h3>
      <div
        className="opds-styles-v1-text-body-medium"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.default,
        }}
      >
        <Message id="course2.task1.body" />
      </div>
      <Row style={{ marginTop: space.default, marginLeft: 0, marginRight: 0 }}>
        <Col
          style={{ display: 'flex' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-left-small-padding"
        >
          <RadioQuestionTile
            number="1"
            correctAnswer="2"
            value={selectedValue1}
            setValue={setSelectedValue1}
            courseNumber={2}
            taskNumber={1}
          />
        </Col>
        <Col
          style={{ display: 'flex' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-right-small-padding"
        >
          <RadioQuestionTile
            number="2"
            correctAnswer="1"
            value={selectedValue2}
            setValue={setSelectedValue2}
            courseNumber={2}
            taskNumber={1}
          />
        </Col>
        <Col
          style={{ display: 'flex' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-left-small-padding"
        >
          <RadioQuestionTile
            number="3"
            correctAnswer="2"
            value={selectedValue3}
            setValue={setSelectedValue3}
            courseNumber={2}
            taskNumber={1}
          />
        </Col>
        <Col
          style={{ display: 'flex' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-right-small-padding"
        >
          <RadioQuestionTile
            number="4"
            correctAnswer="2"
            value={selectedValue4}
            setValue={setSelectedValue4}
            courseNumber={2}
            taskNumber={1}
          />
        </Col>
        <Col
          style={{ display: 'flex' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-left-small-padding"
        >
          <RadioQuestionTile
            number="5"
            correctAnswer="3"
            value={selectedValue5}
            setValue={setSelectedValue5}
            courseNumber={2}
            taskNumber={1}
          />
        </Col>
        <Col
          style={{ display: 'flex' }}
          xs={12}
          md={6}
          className="investoracademy-multi-column-right-small-padding"
        >
          <RadioQuestionTile
            number="6"
            correctAnswer="1"
            value={selectedValue6}
            setValue={setSelectedValue6}
            courseNumber={2}
            taskNumber={1}
          />
        </Col>
      </Row>
      {selectedValue1 === '2' &&
        selectedValue2 === '1' &&
        selectedValue3 === '2' &&
        selectedValue4 === '2' &&
        selectedValue5 === '3' &&
        selectedValue6 === '1' && (
          <Alert type="positive">
            <Message id="answers_correct" />
          </Alert>
        )}
    </div>
  );
};

export default TaskOne;
